import type { ISerialize } from '@/objects/ISerialize';
import type { Gender } from './../enums/Gender';
import type { ResultType } from './../enums/ResultType';

export class ResultSearchRequest implements ISerialize {
    public CategoryID: number | null;

    public EventID: number;

    public Gender: Gender | null;

    public Lap: number = 1;

    public NumberOfItems: number = 10;

    public RaceID: number;

    public ResultType: ResultType;

    public StartingAt: number = 1;

    public StationID: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        CategoryID?: number | null;
        EventID?: number;
        Gender?: Gender | null;
        Lap?: number;
        NumberOfItems?: number;
        RaceID?: number;
        ResultType?: ResultType;
        StartingAt?: number;
        StationID?: number | null;
    }) {
        this.CategoryID = values.CategoryID ?? null;

        this.EventID = values.EventID ?? 0;

        this.Gender = values.Gender ?? 'm';

        this.Lap = values.Lap ?? 1;

        this.NumberOfItems = values.NumberOfItems ?? 10;

        this.RaceID = values.RaceID ?? 0;

        this.ResultType = values.ResultType ?? 'Overall';

        this.StartingAt = values.StartingAt ?? 1;

        this.StationID = values.StationID ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"CategoryID": ${JSON.stringify(this.CategoryID)}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"Gender": ${this.Gender == null ? null : this.Gender == 'm' ? 0 : this.Gender == 'f' ? 1 : this.Gender == 'n' ? 2 : null}` +
            ',' +
            `"Lap": ${JSON.stringify(this.Lap)}` +
            ',' +
            `"NumberOfItems": ${JSON.stringify(this.NumberOfItems)}` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            ',' +
            `"ResultType": ${this.ResultType == 'Overall' ? 0 : this.ResultType == 'Category' ? 1 : this.ResultType == 'Gender' ? 2 : 0}` +
            ',' +
            `"StartingAt": ${JSON.stringify(this.StartingAt)}` +
            ',' +
            `"StationID": ${JSON.stringify(this.StationID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ResultSearchRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        CategoryID?: number | null;
        EventID?: number;
        Gender?: Gender | null;
        Lap?: number;
        NumberOfItems?: number;
        RaceID?: number;
        ResultType?: ResultType;
        StartingAt?: number;
        StationID?: number | null;
    }): ResultSearchRequest {
        return new ResultSearchRequest(values);
    }

    public static _FromServerJson(json: any): ResultSearchRequest {
        return new ResultSearchRequest({
            CategoryID: json.CategoryID ?? null,
            EventID: json.EventID,
            Gender: json.Gender == null ? null : json.Gender == 0 ? 'm' : json.Gender == 1 ? 'f' : json.Gender == 2 ? 'n' : null,
            Lap: json.Lap,
            NumberOfItems: json.NumberOfItems,
            RaceID: json.RaceID,
            ResultType: json.ResultType == 0 ? 'Overall' : json.ResultType == 1 ? 'Category' : json.ResultType == 2 ? 'Gender' : 'Overall',
            StartingAt: json.StartingAt,
            StationID: json.StationID ?? null,
        });
    }

    /**
     * Creates an instance of ResultSearchRequest from another instance of ResultSearchRequest.
     * @param other The ResultSearchRequest you want to clone
     * @returns A cloned ResultSearchRequest
     */
    public static FromOther(other: ResultSearchRequest): ResultSearchRequest {
        return ResultSearchRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ResultSearchRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'ResultSearchRequest';
}
